import { ActionFunction, useLoaderData } from "react-router-dom";
import { authenticatedRedirect } from "../../../common/api/decimal/methods/user.ts";
import {
  allowedDomains,
  allowedProtocols,
  blockedProtocols,
} from "./trustConfig.ts";
import { getDomain } from "../../../common/utils/url.ts";

interface RedirectLoaderData {
  type: "safe" | "consent-required" | "blocked";
}

export const redirectLoader: ActionFunction = ({
  request,
}): RedirectLoaderData => {
  const urlStr = new URL(request.url).searchParams.get("url");

  if (urlStr) {
    const urlObj = new URL(urlStr);

    if (blockedProtocols.includes(urlObj.protocol)) {
      return { type: "blocked" };
    }

    if (
      allowedProtocols.includes(urlObj.protocol) &&
      allowedDomains.includes(getDomain(urlObj.hostname))
    ) {
      return { type: "safe" };
    }

    return { type: "consent-required" };
  }

  throw new Error("URL invalid or missing");
};

export const redirectAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const url = formData.get("url") as string;
  if (url) {
    const response = await authenticatedRedirect(url);
    if (!response.ok) {
      // Fallback to unauthenticated url if authenticted redirect fails.
      window.location.href = url;
    }
    if (response.ok && response.data?.redirectUri) {
      window.location.href = response.data.redirectUri;
    }
  }
  return {};
};

export function useRedirectLoaderData() {
  return useLoaderData() as RedirectLoaderData;
}
